import React from "react";
import { FormGroup, Label } from "reactstrap";
import { StyledSelect as Select } from "../components/inputs/StyledSelect";

export const SplitPicker = ({ split, testOptions, onChangeTest, disabled }) => (
  <div className="mb-4">
    <FormGroup row>
      <Label className="col-sm-3 col-form-label">Test</Label>

      <div className="col-sm-10 col-md-9">
        <Select isMulti isClearable options={testOptions} value={split.tests} onChange={onChangeTest} isDisabled={disabled} />
      </div>
    </FormGroup>
  </div>
);
